// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { ExternalLink as RawExternalLink } from "lucide-react";
export const ExternalLink = /* @__PURE__ */ createIcon(RawExternalLink, "ExternalLink", 2);
